import * as React from "react";
import { OnboardingModal } from "./onboardingModalHandler";
import { render } from "../../common/reactUtils";

export const initialize = () =>
  render(<OnboardingModal />, "#js-react-onboarding-app");
